import { render, staticRenderFns } from "./WidgetCatalog.vue?vue&type=template&id=fbce9784"
import script from "./WidgetCatalog.vue?vue&type=script&lang=js"
export * from "./WidgetCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports